// API timestamps represent UTC even when MongoDB serialization omits the zone.
// Calendar dates and local form inputs are handled separately from instants.
export const parseUtcTimestamp = (value) => {
  if (value === null || value === undefined || value === "") return null;
  let normalized = value;
  if (typeof value === "string") {
    normalized = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      normalized += "T00:00:00";
    } else if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(normalized)) {
      normalized = normalized.replace(" ", "T");
      if (!/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized)) normalized += "Z";
    } else {
      return null;
    }
  } else if (!(value instanceof Date) && typeof value !== "number") {
    return null;
  }
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

const pad = (value) => String(value).padStart(2, "0");
const calendarDate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const toLocalDateInput = (value) => {
  const date = parseUtcTimestamp(value);
  return date ? calendarDate(date) : "";
};

export const toLocalDateTimeInput = (value) => {
  const date = parseUtcTimestamp(value);
  return date ? `${calendarDate(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}` : "";
};

export const localDateTimeToUtc = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};
